import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { useSurveys } from 'contexts/surveys'
import { useAccess } from 'contexts/access'
import { useUpgradable } from 'hooks/upgradable'
import { useOptionedString } from 'hooks/optioned-string'
import { useLocationStateIntent } from 'hooks/location-intent'
import { HeroColumns } from './s'
import ModuleTitle from 'components/module-title'
import { Action } from 'components/hero-actions'
import ContextMenu, { getBoundActions } from 'widgets/context-menu'
import { Ghost, ButtonArrow } from 'components/button'
import Modal from 'modals/dialog'
import Add from 'pages/surveys/modals/survey/add'
import { AI } from 'components/feather'
import { Smile as EmployeeSatisfaction } from 'styled-icons/feather'

const customSurveysFeature = { feature: 'surveys-custom' }

const SurveysHero = ({ salt }) => {
    const { formatMessage } = useIntl()
    const optionizeString = useOptionedString()

    const { check } = useAccess()
    const checkUpgradable = useUpgradable()

    const surveyAdmin = check('surveys:write')
    const customSurveysUpgradable = checkUpgradable(customSurveysFeature)

    const {
        surveys,
        hasFetched
    } = useSurveys()

    const [adding, setAdding] = useState(null)

    useLocationStateIntent({
        intent: 'create-custom-survey',
        action: () => setAdding({ type: 'custom' })
    })

    useLocationStateIntent({
        intent: 'create-enps-survey',
        action: () => setAdding({ type: 'enps' })
    })

    const actions = getBoundActions({
        custom: () => ({
            salt: `${salt}:custom`,
            icon: <AI size={24} />,
            label: formatMessage({
                id: 'survey_type_custom_label',
                defaultMessage: 'Custom survey'
            }),
            helptext: formatMessage({
                id: 'survey_type_custom_description',
                defaultMessage: 'Define your own questions'
            }),
            onClick: () => setAdding({ type: 'custom' }),
            effect: 'neutral',
            ...(customSurveysUpgradable ? {
                upgrade: customSurveysFeature
            } : null)
        }),
        enps: () => ({
            salt: `${salt}:enps`,
            icon: <EmployeeSatisfaction size={24} />,
            label: formatMessage({
                id: 'survey_type_enps_label',
                defaultMessage: 'eNPS survey'
            }),
            helptext: 'Employee Net Promoter Score®',
            onClick: () => setAdding({ type: 'enps' }),
            effect: 'neutral'
        })
    })

    return (
        <HeroColumns>
            <ModuleTitle which="surveys" />
            {surveyAdmin && (
                <>
                    <Action>
                        <ContextMenu
                            prebound actions={actions}
                            trigger={(
                                <Ghost className="constructive">
                                    {optionizeString(formatMessage({
                                        id: 'surveys_action_create',
                                        defaultMessage: 'New survey'
                                    }))}
                                </Ghost>
                            )}
                            salt={salt} />
                            {(!surveys.length && hasFetched) && <ButtonArrow className="top" />}
                    </Action>
                    <Modal
                        show={!!adding}
                        dismiss={() => setAdding(null)}
                        className="scrollable"
                        salt={salt}>
                        <Add
                            {...adding}
                            salt={salt} />
                    </Modal>
                </>
            )}
        </HeroColumns>
    )
}

export default SurveysHero